import { mapActions } from "vuex";

export const cartMixin = {
  methods: {
    ...mapActions("cart", ["addItemToCart"]),

    addItem(item) {
      let payload = {};

      if (item !== null) {
        payload = item;
      } else {
        payload = {
          id: this.$store.state.cart.cart.length + 1,
          name: "",
          grade: "",
          qty: ""
        };
      }
      // mutate the store
      this.addItemToCart(payload);
    }
  }
};
